import React, { Component, PropTypes, cloneElement } from 'react';
import { connect } from 'react-redux';
import {
  updateProps as updatePropsAction,
  getTemplates as getTemplatesAction,
  getLocations as getLocationsAction,
  clearStore as clearStoreAction,
  getContractRequestInfo as getContractRequestInfoAction,
} from '../../../stores/contracting/supplier-wizard/actions';
class SupplierWizardContainer extends Component {
  componentWillMount() {
    this.props.getLocations();
    this.props.getTemplates();
    if (this.props.params.contractId) this.props.getContractRequestInfo(this.props.params.contractId);
  }

  componentWillUnmount() {
    this.props.clearStore();
  }
  render() {
    const { children, ...extraProps } = this.props;
    const allProps = {
      router: this.context.router,
      ...extraProps,
    };
    return (
      <div style={{ width: '100%', maxWidth: '1000px', margin: 'auto' }}>
        {children ? cloneElement(children, allProps) : undefined}
      </div>
    );
  }
}
SupplierWizardContainer.propTypes = {
  children: PropTypes.object,
  params: PropTypes.object,
  updateProps: PropTypes.func,
  getTemplates: PropTypes.func,
  getLocations: PropTypes.func,
  clearStore: PropTypes.func,
  sendContracts: PropTypes.func,
  getContractRequestInfo: PropTypes.func,
};

const mapDispatchToProps = dispatch => ({
  updateProps: (payload) => dispatch(updatePropsAction(payload)),
  clearStore: () => dispatch(clearStoreAction()),
  getTemplates: () => dispatch(getTemplatesAction()),
  getLocations: () => dispatch(getLocationsAction()),
  getContractRequestInfo: (...args) => dispatch(getContractRequestInfoAction(...args)),
});
const mapStateToProps = () => ({});

SupplierWizardContainer.contextTypes = {
  router: React.PropTypes.object.isRequired,
};
export default connect(mapStateToProps, mapDispatchToProps)(SupplierWizardContainer);



// WEBPACK FOOTER //
// ./src/app/components/contracting/supplier-wizard/container.jsx